import axios from "axios";
import { getConfig } from "../helpers/config";

export class RichiestaService {
  baseAPIUrl = `${getConfig()?.url}richieste`;

  getAll = async (filters) => {
    return await axios
      .post(`${this.baseAPIUrl}/all`, filters)
      .then((res) => res.data);
  };

  get = async (id) => {
    return await axios.get(`${this.baseAPIUrl}/${id}`).then((res) => res.data);
  };

  canCreateNewRequest = async () => {
    return await axios
      .get(`${this.baseAPIUrl}/can-create`)
      .then((res) => res.data);
  };

  canUndoRequest = async () => {
    return await axios
      .get(`${this.baseAPIUrl}/can-undo`)
      .then((res) => res.data);
  };

  create = async (data) => {
    return await axios
      .post(`${this.baseAPIUrl}/`, data)
      .then((res) => res.data);
  };

  saveStep1 = async (idRichiesta, data) => {
    return await axios.post(`${this.baseAPIUrl}/${idRichiesta}/step1`, data)
      .then((res) => res.data);
  };

  saveStep2 = async (idRichiesta, tipoRichiedente) => {
    try {
      const formData = new FormData();
      formData.append("tipoRichiedente", tipoRichiedente);

      const response = await axios.post(
        `${this.baseAPIUrl}/${idRichiesta}/step2`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      return response.data;
    } catch (error) {
      console.error("Errore durante il salvataggio dello step 2:", error);
      throw error;
    }
  };

  saveStep3 = async (idRichiesta, data) => {
    return await axios.post(`${this.baseAPIUrl}/${idRichiesta}/step3`, data)
      .then((res) => res.data);
  };

  delete = async (id) => {
    return await axios.delete(`${this.baseAPIUrl}/${id}`)
      .then((res) => res.data);
  };

  saveStep4 = async (richiestaId, iscrizioneScolastica) => {
    return await axios.post(`${this.baseAPIUrl}/${richiestaId}/step4`, iscrizioneScolastica).then(resp => resp.data);
  }

  saveStep5 = async (idRichiesta, dsu, iban, denominazioneBanca) => {
    try {
      const response = await axios.post(
        `${this.baseAPIUrl}/${idRichiesta}/step5`,
        {
          dsu, iban, denominazioneBanca
        }
      );

      return response.data;
    } catch (error) {
      console.error("Errore durante il salvataggio dello step 5", error);
      throw error;
    }
  };

  presentaDomanda = async (id) => {
    return axios.post(`${this.baseAPIUrl}/${id}/presenta`).then(res => res.data);
  }

  presentaDomandaRiapertura = async (id) => {
    return axios.post(`${this.baseAPIUrl}/${id}/presenta/riapertura`).then(res => res.data);
  }

  downloadPdf = async (richiestaId) => {
    try {
      const response = await axios.get(`${this.baseAPIUrl}/${richiestaId}/pdf`, {
        responseType: 'blob',
      });
      return response;
    } catch (error) {
      console.error('Errore durante il download del PDF:', error);
    }
  };

  getAllDt = async (data) => {
    return await axios.post(`${this.baseAPIUrl}/alldt`, data)
      .then(res => res.data);
  }

  getAllDtMassivo = async (data) => {
    return await axios.post(`${this.baseAPIUrl}/allDt/massive`, data)
      .then(res => res.data);
  }

  downloadIsee = async (richiestaId) => {
    try {
      const response = await axios.get(`${this.baseAPIUrl}/${richiestaId}/isee`, {
        responseType: 'blob',
      });
      return response;
    } catch (error) {
      console.error('Errore durante il download della risposta ISEE:', error);
    }
  };

  checkIsee = async (richiestaId) => {
    try {
      const response = await axios.get(
        `${this.baseAPIUrl}/${richiestaId}/isee/check`);

      return response.data;
    } catch (error) {
      console.error('Errore durante il download della risposta ISEE:', error);
    }
  }

  annullaDomanda = async (idRichiesta) => {
    return await axios.put(`${this.baseAPIUrl}/${idRichiesta}/annulla`, null)
      .then((res) => res.data);
  };

  rinunciaDomanda = async (idRichiesta) => {
    return await axios.put(`${this.baseAPIUrl}/${idRichiesta}/rinuncia`, null)
      .then((res) => res.data);
  };

  startEsportazioneDomande = async (avvisoId, faseId) => {
    return await axios.get(`${this.baseAPIUrl}/${avvisoId}/${faseId}/startExportExcel`).then(res => res.data);
  }

  downloadEsportazioneDomande = async () => {
    return await axios.get(`${this.baseAPIUrl}/downloadExport`).then(res => res.data);
  }

  rescheduleProtocolli = async (avvisoId) => {
    return await axios.put(`${this.baseAPIUrl}/${avvisoId}/rescheduleProtocolli`)
      .then((res) => res.data);
  }

  rescheduleEmail = async (avvisoId) => {
    return await axios.put(`${this.baseAPIUrl}/${avvisoId}/rescheduleEmail`)
      .then((res) => res.data);
  }

  rescheduleIsee = async (avvisoId) => {
    return await axios.put(`${this.baseAPIUrl}/${avvisoId}/rescheduleIsee`)
      .then((res) => res.data);
  }

  aggiornaDomanda = async (richiestaId, body) => {
    return await axios.post(`${this.baseAPIUrl}/${richiestaId}/aggiorna`, body)
      .then((res) => res.data);

  }

  aggiornaSecondoAccessoDomanda = async (richiestaId, body) => {
    return await axios.post(`${this.baseAPIUrl}/${richiestaId}/secondo-accesso`, body)
      .then((res) => res.data);
  }

  aggiornaTerzoAccessoDomanda = async (richiestaId, body) => {
    return await axios.post(`${this.baseAPIUrl}/${richiestaId}/terzo-accesso`, body)
      .then((res) => res.data);
  }

  countCheckIban = async (avvisoId, tipologiaFase) => {
    try {
      const count = await axios.get(
        `${this.baseAPIUrl}/${avvisoId}/fase/${tipologiaFase}/count-check-iban`);

      return count.data;
    } catch (error) {
      console.error('Errore:', error);
      throw error;
    }
  }

  startCheckIban = async (avvisoId, tipologiaFase) => {
    try {
      return await axios.get(
        `${this.baseAPIUrl}/${avvisoId}/fase/${tipologiaFase}/check-iban`);
    } catch (error) {
      console.error('Errore:', error);
      throw error;
    }
  }

  countCheckArs = async (faseId) => {
    try {
      const count = await axios.get(
        `${this.baseAPIUrl}/fase/${faseId}/count-check-ars`);

      return count.data;
    } catch (error) {
      console.error('Errore:', error);
      throw error;
    }
  }

  startCheckArs = async (faseId) => {
    try {
      return await axios.get(
        `${this.baseAPIUrl}/fase/${faseId}/check-ars`);
    } catch (error) {
      console.error('Errore:', error);
      throw error;
    }
  }

  downloadControlloIban = async (richiestaId) => {
    try {
      const response = await axios.get(`${this.baseAPIUrl}/${richiestaId}/download-check-iban`, {
        responseType: 'blob',
      });
      return response;
    } catch (error) {
      console.error('Errore durante il download della risposta del controllo IBAN:', error);
    }
  };

  rettificaIban = async (richiestaId, body) => {
    try {
      return await axios.post(`${this.baseAPIUrl}/${richiestaId}/rettifica-iban`, body);
    } catch (error) {
      console.error("Errore nella rettifica iban");
      throw error;
    }
  }

  salvaStep4Riapertura = async (idRichiesta, body) => {
    try {
      const response = await axios.post(`${this.baseAPIUrl}/${idRichiesta}/step4-ripresentazione`, body);

      return response.data;
    } catch (error) {
      console.error("Errore durante il salvataggio dello step 4", error);
      throw error;
    }
  }

  rettificaDomandaRipresentazione = async (richiestaId, body) => {
    return await axios.post(`${this.baseAPIUrl}/${richiestaId}/rettifica-ripresentazione`, body)
      .then((res) => res.data);
  }

  invertiEsitoPagamento = async (idRichiesta, motivazioneKo) => {
    try {
      const headers = {
        'Content-Type': 'text/plain'
      };
      const response = await axios.post(`${this.baseAPIUrl}/${idRichiesta}/inverti-esito-pagamento`, motivazioneKo, {headers});

      return response.data;
    } catch (error) {
      console.error("Errore durante il salvataggio dello step 4", error);
      throw error;
    }
  }
}
